import React from "react";
import NavBar from "layout/navbar";
import SideBar from "layout/sidebar";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import WorkspacesContent from "layout/systemAdmin/workspaces/WorkspacesContent";
import SystemAdminTabs from "layout/systemAdmin/SystemAdminTabs";
import UsersContent from "layout/systemAdmin/users/UsersContent";
import LicenseContent from "layout/systemAdmin/license/LicenseContent";
import AuthenticationContent from "layout/systemAdmin/authentication/AuthenticationContent";
import {
  SYSTEM_ADMIN_LICENSE,
  SYSTEM_ADMIN_SECURITY,
  SYSTEM_ADMIN_USERS,
  SYSTEM_ADMIN_WORKSPACES,
} from "constants/routes";
import ModalsHolder from "layout/discovery/ModalsHolder";
import { AlertsHolder } from "components/Alert";

const SystemAdmin = () => (
  <div className="system_admin">
    <NavBar />
    <SideBar />
    <HashRouter>
      <ModalsHolder />
      <AlertsHolder />
      <SystemAdminTabs />
      <Routes>
        <Route path={SYSTEM_ADMIN_WORKSPACES} element={<WorkspacesContent />} />
        <Route path={SYSTEM_ADMIN_USERS} element={<UsersContent />} />
        <Route path={SYSTEM_ADMIN_LICENSE} element={<LicenseContent />} />
        <Route
          path={SYSTEM_ADMIN_SECURITY}
          element={<AuthenticationContent />}
        />
        <Route
          path="*"
          element={<Navigate to={SYSTEM_ADMIN_WORKSPACES} replace />}
        />
      </Routes>
    </HashRouter>
  </div>
);

export default SystemAdmin;
